import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Field } from 'redux-form';
import _trim from 'lodash/trim';

import FormColorPalette from 'components/Form/components/FormColorPalette';
import { FormGroupField } from 'components/Form';

import styles from './style.scss';

class FormNamedColorPalette extends Component {
  static propTypes = {
    isDisabled: PropTypes.bool,
    name: PropTypes.shape({
      meta: PropTypes.shape({
        invalid: PropTypes.bool,
        active: PropTypes.bool,
        touched: PropTypes.bool,
      }),
    }).isRequired,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    handlersOfNameInputRef: PropTypes.arrayOf(PropTypes.func),
    autoFocus: PropTypes.bool,
  };

  static defaultProps = {
    isDisabled: false,
    placeholder: '',
    className: '',
    handlersOfNameInputRef: [],
    autoFocus: false,
  };

  componentDidMount() {
    this.focusNameInput();
  }

  focusNameInput = () => {
    const { autoFocus } = this.props;

    if (autoFocus && this.nameInputRef) {
      this.nameInputRef.focus();
    }
  };

  handleNameInputRef = el => {
    // This component accepts handlersOfNameInputRef which contains an array of handlers
    // That way when onInputRef is called more that one handlers are called
    const { handlersOfNameInputRef } = this.props;
    const updatedHandlersOfNameInputRef = [
      ...handlersOfNameInputRef,
      el => {
        this.nameInputRef = el;
      },
    ];
    updatedHandlersOfNameInputRef.forEach(handlerOfNameInputRef => {
      handlerOfNameInputRef(el);
    });
  };

  render() {
    const { isDisabled, name, className, placeholder } = this.props;
    return (
      <div
        styleName={cn('named-color-palette', {
          'is-error': !isDisabled && name.meta.invalid && name.meta.touched,
          'is-focused': !isDisabled && name.meta.active,
          'is-disabled': isDisabled,
        })}
        className={className}
      >
        <Field
          name="color"
          isDisabled={isDisabled}
          component={FormColorPalette}
        />
        <Field
          styleName="input"
          type="text"
          normalize={_trim}
          name="name"
          disabled={isDisabled}
          component={FormGroupField}
          placeholder={placeholder}
          errorClassName={styles['error-container']}
          onInputRef={this.handleNameInputRef}
          data-test="name"
        />
      </div>
    );
  }
}

export default FormNamedColorPalette;
